// Lightweight user wrapper for field_view users in IMG UI.
// Intentionally minimal: field_view is a prod read-only persona used to
// confirm auth + CORS work end-to-end. No dealer-group/onboarding plumbing.
export default class FieldView {
  constructor(userDetails, history) {
    if (userDetails) {
      this.userId = userDetails.userId;
      this.commonName = userDetails.commonName;
      this.fullName = userDetails.fullName;
      this.market = userDetails.market;
      this.userType = userDetails.userType;
      this.roles = userDetails.roles;
      this.permissions = userDetails.permissions;
      this.brand = userDetails.brand;
      this.dealerBrand = userDetails.dealerBrand;
      this.salesCode = userDetails.salesCode;
      this.dealerId = userDetails.dealerId;
      this.commonId = userDetails.commonId;
    }
    this.history = history;
    this.readOnly = true;
  }

  generateResourcePath() {
    return `field/${this.market}`;
  }

  updateBusinessSettingsTab(tab) {
    this.businessSettingsPage = tab;
  }

  updateDashboardTab(tab) {
    this.dashboardPage = tab;
  }

  updateBrand(brand) {
    this.brand = brand;
  }
}
